import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServiceInfoClientService } from '../../../service/service-info-client.service';
import { FogapeInfoClient } from '../../../interface/fogape-client.interface';


@Component({
  selector: 'app-detalle-fogape',
  templateUrl: './detalle-fogape.component.html',
  styleUrls: ['./detalle-fogape.component.scss']
})
export class DetalleFogapeComponent implements OnInit {

  public fogapeInfo?: FogapeInfoClient;

  constructor(@Inject(MAT_DIALOG_DATA)public data: string, 
  public dialogRef: MatDialogRef<DetalleFogapeComponent>,
  private clientService: ServiceInfoClientService){

  }

  ngOnInit(): void {
    const rut = this.data.replaceAll('.', '').split('-')[0];
    const companyId = Number.parseInt(rut);
    this.clientService.getFogapeInfo(companyId)
    .subscribe({
      next: (response) => {
        this.fogapeInfo = response;
      }
    })
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
